import { render, staticRenderFns } from "./message-alert-list.vue?vue&type=template&id=544fe0e3&"
import script from "./message-alert-list.vue?vue&type=script&lang=ts&"
export * from "./message-alert-list.vue?vue&type=script&lang=ts&"
import style0 from "./message-alert-list.vue?vue&type=style&index=0&id=544fe0e3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports